import maplibregl from "maplibre-gl";

export function createMarkerWithClass(
  map: maplibregl.Map,
  lngLat: [number, number],
  className: string,
  setupElement?: (el: HTMLDivElement) => void,
) {
  const el = document.createElement("div");
  el.className = className;
  if (setupElement) {
    setupElement(el);
  }
  return new maplibregl.Marker({ element: el }).setLngLat(lngLat).addTo(map);
}

export function focusOnPoint(
  map: maplibregl.Map,
  lngLat: [number, number],
  padding: number,
  options?: { maxZoom?: number; durationMs?: number },
) {
  const bounds = new maplibregl.LngLatBounds(lngLat, lngLat);
  const delta = 0.0008;
  bounds.extend([lngLat[0] + delta, lngLat[1] + delta]);
  bounds.extend([lngLat[0] - delta, lngLat[1] - delta]);
  map.fitBounds(bounds, {
    padding,
    maxZoom: options?.maxZoom ?? 18,
    duration: options?.durationMs ?? 450,
  });
}
